// extracted by mini-css-extract-plugin
module.exports = {"sectionColumn":"SectionColumn_sectionColumn__zK51k","title":"SectionColumn_title__R8q8L"};